// src/firebase/init.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyD6c3-jqHv5iENETqDC5J-EqESw5EMGgkk",
  authDomain: "facewave-web.firebaseapp.com",
  projectId: "facewave-web",
  storageBucket: "facewave-web.firebasestorage.app",
  messagingSenderId: "163029822309",
  appId: "1:163029822309:web:c824d4db9a10c906c74f8c",
  measurementId: "G-XQ67KCQFNY" // 只有在使用Google Analytics时才需要
};

// 初始化Firebase应用
const app = initializeApp(firebaseConfig);

// 如果你想使用Google Analytics，那么需要初始化Analytics
export const analytics = getAnalytics(app);